import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

interface MenuItem {
  label: string;
  path: string;
  icon: string;
}

const menuItems: MenuItem[] = [
  { label: "Genel Bakış", path: "/", icon: "ri-dashboard-line" },
  { label: "Rezervasyonlar", path: "/rezervasyonlar", icon: "ri-calendar-check-line" },
  { label: "Takvim / Doluluk", path: "/takvim", icon: "ri-calendar-2-line" },
  { label: "Müşteriler", path: "/musteriler", icon: "ri-user-line" },
  { label: "Giriş - Çıkış", path: "/giris-cikis", icon: "ri-login-box-line" },
  { label: "Odalar", path: "/odalar", icon: "ri-hotel-line" },
  { label: "Ödemeler", path: "/odemeler", icon: "ri-money-dollar-circle-line" },
  { label: "Müşteri Kaynakları", path: "/kaynaklar", icon: "ri-bar-chart-2-line" },
  { label: "Teklif ve Takip", path: "/teklifler", icon: "ri-file-list-3-line" },
  { label: "Görevler", path: "/gorevler", icon: "ri-task-line" },
  { label: "Raporlar", path: "/raporlar", icon: "ri-line-chart-line" },
  { label: "Ayarlar", path: "/ayarlar", icon: "ri-settings-3-line" },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`fixed inset-0 bg-black/40 z-40 lg:hidden transition-opacity duration-300 ${
          collapsed ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
        onClick={() => setCollapsed(true)}
      />

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full z-50 bg-background-50 border-r border-background-200/70 flex flex-col transition-all duration-300 ${
          collapsed ? "-translate-x-full lg:translate-x-0 lg:w-[72px]" : "translate-x-0 w-[260px]"
        } lg:relative lg:z-auto`}
      >
        {/* Logo area */}
        <div className="flex items-center gap-3 px-5 h-16 border-b border-background-200/70 shrink-0">
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
            <i className="ri-hotel-bed-line text-lg text-white"></i>
          </div>
          <div className={`overflow-hidden transition-all duration-300 ${collapsed ? "lg:w-0 lg:opacity-0" : "w-auto opacity-100"}`}>
            <h1 className="text-sm font-semibold text-foreground-900 whitespace-nowrap font-heading">
              İlkim Butik
            </h1>
            <p className="text-[11px] text-foreground-500 whitespace-nowrap">Yönetim Paneli</p>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setCollapsed(true)}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors duration-150 whitespace-nowrap group ${
                  isActive
                    ? "bg-primary-100/80 text-primary-700 font-medium"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                }`}
              >
                <span className={`w-5 h-5 flex items-center justify-center shrink-0 ${collapsed ? "lg:mx-auto" : ""}`}>
                  <i className={`${item.icon} text-base ${isActive ? "text-primary-600" : "text-foreground-400 group-hover:text-foreground-600"}`}></i>
                </span>
                <span className={`overflow-hidden transition-all duration-300 ${collapsed ? "lg:w-0 lg:opacity-0" : "w-auto opacity-100"}`}>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-background-200/70 shrink-0">
          <div className={`flex items-center gap-3 ${collapsed ? "lg:justify-center" : ""}`}>
            <div className="w-8 h-8 rounded-full bg-secondary-500 flex items-center justify-center shrink-0">
              <span className="text-xs font-semibold text-foreground-900">İO</span>
            </div>
            <div className={`overflow-hidden transition-all duration-300 ${collapsed ? "lg:w-0 lg:opacity-0" : "w-auto opacity-100"}`}>
              <p className="text-xs font-medium text-foreground-800 whitespace-nowrap">İlkim Butik Otel</p>
              <p className="text-[10px] text-foreground-500 whitespace-nowrap">Marmaris / Orhaniye</p>
            </div>
          </div>
        </div>

        {/* Toggle button - desktop only */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="hidden lg:flex absolute -right-3 top-20 w-6 h-6 rounded-full bg-background-100 border border-background-200 items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
        >
          <i className={`ri-arrow-left-s-line text-xs text-foreground-500 transition-transform ${collapsed ? "rotate-180" : ""}`}></i>
        </button>
      </aside>

      {/* Mobile hamburger */}
      <button
        onClick={() => setCollapsed(false)}
        className="lg:hidden fixed top-3 left-3 z-30 w-9 h-9 rounded-lg bg-background-50 border border-background-200 flex items-center justify-center cursor-pointer hover:bg-background-100 transition-colors"
      >
        <i className="ri-menu-line text-foreground-600"></i>
      </button>
    </>
  );
}